module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_third.255e8ccf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_third.png
// module id = 3466
// module chunks = 11